var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 24.5V22.1667C23.3333 20.929 22.8417 19.742 21.9665 18.8668C21.0913 17.9917 19.9043 17.5 18.6667 17.5H9.33332C8.09565 17.5 6.90866 17.9917 6.03349 18.8668C5.15832 19.742 4.66666 20.929 4.66666 22.1667V24.5M18.6667 8.16667C18.6667 10.744 16.5773 12.8333 14 12.8333C11.4227 12.8333 9.33332 10.744 9.33332 8.16667C9.33332 5.58934 11.4227 3.5 14 3.5C16.5773 3.5 18.6667 5.58934 18.6667 8.16667Z",
    stroke: "#475467",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6bbd8f74dfc71b24a70d305702a04e1f.svg";
export { ForwardRef as ReactComponent };